// English (base) dictionary for the User Panel
const en = {
  common: {
    loading: "Loading...",
    back: "Back",
    cancel: "Cancel",
    confirm: "Confirm",
    save: "Save",
    saved: "Saved",
    submit: "Submit",
    submitting: "Submitting...",
    saving: "Saving...",
    ok: "OK",
    error: "Error",
    success: "Success",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    completed: "Completed",
    all: "All",
    failed: "Failed",
    select_language: "Select Language",
    language: "Language",
    unable_server: "Unable to reach server. Please try again.",
    fill_all: "Please fill in all fields",
    hint_disabled: "Deposits and withdrawals are currently disabled",
    account_disabled: "Transactions are disabled for your account. Please contact support.",
  },

  navbar: {
    home: "Home",
    history: "History",
    starting: "Starting",
    services: "Services",
    my_profile: "My Profile",
  },

  page: {
    home: "Home",
    history: "History",
    services: "Services",
    deposit: "Deposit",
    withdraw: "Withdraw",
    widthraw_page: "Withdraw",
    withdrawal_account: "Withdrawal Account",
    deposit_history: "Deposit History",
    withdraw_history: "Withdraw History",
    starting: "Starting",
    my_profile: "My Profile",
    security_pin: "Security Pin",
    login_password: "Login Password",
    invite_friends: "Invite Friends",
    about_us: "About Us",
    faq: "FAQ",
    vip_rules: "VIP Rules",
    invitation_rules: "Invitation Rules",
    about_us_details: "About Us",
  },

  home: {
    welcome: "Welcome",
    vip_level: "VIP Levels",
    popular: "Popular",
    deposit: "Deposit",
    withdrawal: "Withdrawal",
    about_us: "About Us",
    invite_friends: "Invite Friends",
  },

  deposit: {
    title: "Deposit",
    amount_label: "Deposit Amount",
    total_balance: "Total Balance",
    bank_card: "Bank Card",
    quick_selection: "Quick Selection",
    err_amount: "Please enter a valid deposit amount",
    range_hint: "Allowed range for {vip}: {min} - {max}",
    err_below: "Deposit amount cannot be less than {min}",
    err_above: "Deposit amount cannot exceed {max}",
    err_loading_card: "Please wait, loading your bank card",
    err_add_card: "Please add your bank card in My Profile → Withdrawal Account first",
    info_title: "Bank Card Information",
    info_hint:
      "Bank card details are automatically taken from your Withdrawal Account (My Profile).",
    bank_name: "Bank Name",
    card_number: "Card Number",
    account_holder: "Account Holder Name",
    ph_bank_name: "Enter bank name",
    ph_card_number: "Enter card number",
    ph_account_holder: "Enter name on bank account",
    waiting_title: "Waiting for Approval....",
    waiting_text:
      "Your recharge request has been submitted. Please wait for admin confirmation.",
  },

  withdraw: {
    title: "Withdraw",
    amount_label: "Withdrawal Amount",
    total_balance: "Total Balance",
    method_title: "Withdrawal Method",
    method_hint:
      "These details come from your Withdrawal Account (My Profile) and can't be edited here.",
    bank_card: "Bank Card",
    usdt: "USDT",
    wise: "Wise",
    revolut: "Revolut",
    bank_name: "Bank Name",
    bank_account: "Bank Account/USDT",
    full_name: "Full Name",
    usdt_address: "USDT Address",
    usdt_protocol: "USDT Protocol",
    wise_email: "Wise account email",
    wallet_address: "Wallet address",
    security_pin: "Security PIN",
    time_title: "Withdrawal Time",
    time_text:
      "Withdrawals are allowed between 01:00:00 and 17:00:00 only. Please try again during this time.",
    success: "Withdrawal request submitted, waiting for approval",
    err_amount: "Please enter a valid withdrawal amount",
    err_pin: "Please enter your security pin",
    err_loading: "Please wait, loading your withdrawal account",
    err_details:
      "Please add your {method} details in My Profile → Withdrawal Account first",
    err_bank: "Please fill in Bank Name, Account Number and Full Name",
    err_usdt: "Please fill in USDT address and full name",
    err_wise: "Please fill in Wise account email and full name",
    err_revolut: "Please fill in wallet address and full name",
    limit_title: "Request Error",
    err_below: "Withdrawal amount cannot be less than {min}",
    err_above: "Withdrawal amount cannot exceed {max}",
    err_daily: "Daily withdrawal limit reached. You are allowed {count} withdrawal(s) per day.",
  },

  waccount: {
    title: "Withdrawal Account",
    hint:
      "These details are used automatically for Deposit and Withdraw. Once submitted, they are saved to the admin's Bank Card List.",
    usdt_number: "USDT Number",
    confirm_text: "Are you sure you want to save these withdrawal account details?",
    saved_success: "Withdrawal account saved successfully",
  },

  history: {
    pending: "Pending",
    completed: "Completed",
    no_records: "No records found",
    total_amount: "Total amount:",
    profit: "Profit:",
    volume: "Transaction volume:",
    order_submitted: "Order submitted successfully",
  },

  start: {
    current: "Current",
    profit: "Profit:",
    application: "Application:",
    welcome: "Hi! Welcome",
    commission_details: "Commission Details",
    today_profit: "Today's Profit",
    account_balance: "Account Balance",
    starting: "Starting",
    important_notice: "Important Notice",
    working_hours: "• Working hours: 09:00:00 - 23:58:59",
    contact_line: "• If any question please contact online customer services!",
    processing: "Processing...",
    start: "Start",
    order_product: "Order Product",
    rating: "Rating:",
    price: "Price:",
    commission: "Commission:",
    order_done: "Order completed! Profit {amount} added to your balance.",
    unable_server: "Unable to reach server",
  },

  sv: {
    online: "Online",
    customer: "Customer",
    services: "Services",
  },

  mp: {
    invitation_code: "Invitation Code",
    credit_reputation: "Credit Reputation",
    today_profit: "Today's Profit",
    account_balance: "Account Balance",
    orders_count: "Number of Orders",
    invite_friends: "Invite Friends",
    invite_subtitle: "Invite Friends to Get Rewards",
    logout: "Logout",
    logout_confirm: "Are you sure you want to logout?",
    footer: "Copyright © 2023 Nativz All Rights Reserved.",
    user: "User",
  },

  lp: {
    old_password: "Old Password",
    new_password: "New Password",
    confirm_password: "Confirm New Password",
    note: "Please contact the customer service if you forget your old login password.",
    err_min: "New password must be at least 6 characters",
    err_mismatch: "New password and confirm password do not match",
  },

  sp: {
    old_pin: "Old Pin",
    new_pin: "New Pin",
    confirm_pin: "Confirm New Pin",
    note: "Please contact the customer service if you forget your old Security Pin.",
    err_min: "New pin must be at least 6 characters",
    err_mismatch: "New pin and confirm pin do not match",
  },

  dh: {
    title: "Deposit History",
    empty: "No deposit history yet",
  },

  wh: {
    title: "Withdraw History",
    empty: "No withdraw history yet",
  },

  ifr: {
    title: "Invite Friends",
    link_copied: "Link copied",
    copy_prompt: "Copy this link:",
  },

  faq: {
    title: "FAQ",
    important_reminder: "Important Reminder",
    reminder_text:
      "Any malicious money laundering activities are strictly prohibited. Upon discovery, the platform will freeze the following accounts and take appropriate legal action.",
    deposit_heading: "Deposit",
    deposit_text:
      "Each deposit needs to be submitted to customer service for assistance in replenishing your account. After transferring funds to the account provided by the platform's support team, please provide proof of successful transfer. To ensure immediate receipt of your deposit, please ensure the name of the recipient and the amount transferred match. If you encounter any unresolved issues during the deposit process, please contact customer service. Due to the large amount of information, please carefully review the details before completing the transaction. The platform may change your account information from time to time. If you encounter any unresolved issues during the deposit process, please contact customer service. Have any questions, please contact the platform's online customer service for further assistance.",
    withdraw_heading: "Withdraw funds",
    withdraw_text:
      'Before withdrawing your funds, please bind your withdrawal address to the platform. To withdraw funds, go to the "Withdraw Funds" screen on the homepage, click the "Withdraw" button, and enter the amount you wish to withdraw and your withdrawal password.',
    note: "(Note: Please contact our customer service for assistance.)",
  },

  ir: {
    title: "Invitation Rules",
    p1: "Platform members can use referral codes to invite others to join your team. You will receive a percentage commission on your team members' earnings. Earnings will be directly returned to you through your account on the platform or in your team reports.",
    notice: "Notice:",
    p2: "All agents and their downline members receive a certain percentage of income and bonuses from the platform. Income is 30% of the commissions earned by their downline participants. The platform does not provide support for the development of downline team members, nor does it negatively impact agent income and bonuses.",
  },

  vr: {
    title: "VIP Rules",
    p1: "VIP 1 consists of 30 orders per cycle. To complete these orders, a minimum balance of 25 USDT is required. The withdrawal limit for this level ranges from 100 USDT to a maximum of 5,000 USDT.",
    p2: "VIP 2 consists of 40 orders per cycle. To upgrade to VIP 2, a minimum deposit of 1,500 USDT is required. The withdrawal limit for this level ranges from 100 USDT to a maximum of 10,000 USDT.",
    p3: "VIP 3 consists of 50 orders per cycle. To unlock VIP 3, a minimum deposit of 5,000 USDT is required. The withdrawal limit for this level ranges from 100 USDT to a maximum of 50,000 USDT.",
    p4: "VIP 4 consists of 60 orders per cycle. To unlock VIP 4, a minimum deposit of 10,000 USDT is required. The withdrawal limit for this level ranges from 100 USDT to a maximum of 1,000,000 USDT. Users at VIP 4 also receive an additional 10% commission compared to lower VIP levels.",
  },

  ad: {
    title: "About Us",
    intro: "Terms and conditions for registering as a partner, store, platform, or employee in Oneforma.",
    h_agreement: "Your Agreement",
    p1: '1. Before using, viewing, or creating an account on the oneforma.com platform (" OneForma "), please carefully read these terms and conditions ("Terms", "Terms and Conditions"). Your access to and use of OneForma is conditional upon your acceptance and compliance with these Terms and Conditions and with CENTIFIC GLOBAL SOLUTIONS, Inc. (" CENTIFIC "). These Terms apply to all visitors, users, viewers, and others who access or use OneForma.',
    p2: '2. By providing any services or undertaking any projects allocated on the Oneforma platform, you acknowledge that you ("you," your partner, partner store, partner platform, and personnel) have entered into a Service Agreement with CENTIFIC, which contains the terms and conditions and applicable provisions under applicable law, a description of services or a work order, and other written documents mutually agreed upon by both parties ("Agreement"). If there is any conflict between these Terms and Conditions and any prior agreements you have entered into with respect to this subject matter, these Terms and Conditions shall prevail.',
    p3: "3. By registering for or using OneForma, you agree to be bound by this Agreement. If you do not agree to any or all of this Agreement, you may not register on OneForma.",
    h_relationships: "Relationships among all parties",
    p4: "1.1. The Role of CENTIFIC OneForma is a platform under CENTIFIC, located at 14980 NE 31st Way, Suite 100, Redmond, WA 98052. Contact email: omegaguttakdl53@gmail.com",
    p5: 'CENTIFIC provides the OneForma platform, enabling its users to decide and choose to enter into agreements. You provide services to third parties or CENTIFIC (the "Project Owner") that assign work or projects on OneForma. Any services or work you perform under this agreement are for the Project Owner and are not part of CENTIFIC\'s normal business operations (the "Services").',
    h_deliverables: "1.2. Deliverables",
    p6: "CENTIFIC will not provide you with a permanent work location or require you to perform your services at any specially designed location. You should determine the work location for each project at your own discretion. For any project that requires you to work on-site, you reserve the absolute right not to undertake such project.",
    h_statement: "1.3. Your statement",
    p7: "By reading this agreement, you represent and warrant to CENTIFIC that:",
    p8: "You typically engage in independently established trade or business of the same nature as the services provided under this Agreement. You or the project personnel should possess the skills, experience, and qualifications required to perform the services;",
    p9: "You or your project team should provide services in a professional and skilled manner, adhering to best industry standards for similar services, and meeting the requirements of both the central government and the project owner. You or your project team should dedicate sufficient resources to ensure timely and reliable service delivery.",
    p10: "You or your project staff shall perform the services in accordance with all applicable federal, state, and other national and local laws and regulations, including retaining all licenses, permits, and registrations required to perform the services;",
    p11: "You have the right to enter into this agreement, hire project personnel or grant rights in accordance with the relevant terms of this agreement, and you shall bear full responsibility for the performance of all services under this agreement;",
    p12: "You shall provide, at your own expense, all materials, equipment, supplies and other resources necessary for the performance of the Services, including any travel expenses or other costs or expenses incurred by you or your project staff in the performance of the Services; and you or your project staff shall not be eligible for any leave, group medical or life insurance, disability, profit-sharing or retirement benefits, or any other additional benefits or welfare plans offered by CENTIFIC to its employees, and CENTIFIC shall not be liable for withholding or paying any income, wages, Social Security or other federal, state or local taxes, paying any insurance premiums (including unemployment or disability insurance premiums), or obtaining workers' compensation insurance on your behalf, unless otherwise required by applicable law; you shall be responsible for and reimburse CENTIFIC for all such taxes or payments, including penalties and interest, and you specifically waive any right to seek reimbursement from CENTIFIC for any injury that you (and your employees and contractors) may suffer in the performance of the Services under this Agreement.",
    h_term: "2. Term and Termination",
    p13: "2.1. This Agreement shall become effective from the date you register as a OneForma account holder and shall remain in force until the agreement is terminated by mutual agreement of you and CENTIFIC or by either party in accordance with Section 2.2 .",
    p14: "2.2. Termination Notwithstanding any provision to the contrary in this Agreement, CENTIFIC may terminate your registration on OneForma at any time, for any reason or no reason, upon giving 30 days' written notice. In addition to any remedies that may be provided for in this Agreement, CENTIFIC may also terminate this Agreement immediately upon notice to you if you:",
    p15: "Before or at the time of signing this Agreement, the Company failed to provide the relevant information or documents that CENTIFIC reasonably requested, or provided CENTIFIC with false or misleading information or documents.",
    p16: "Engaging in any fraudulent activity, including but not limited to:",
    p17: "Forging your attendance card; overcharging; making any misleading or fraudulent statements to CENTIFIC or the project owner using automated machines to perform services without the project owner's prior approval;",
    p18: "A material breach of this Agreement and the Confidentiality Agreement, and such breach is irreparable, or even if it is reparable, it is not repaired within 7 days of the issuance of notice of such breach; or a breach of any representation or warranty made by you under this Agreement or the corresponding SOW.",
    p19: "You may terminate this Agreement by deleting your account from OneForma. In this case, you should provide CENTIFIC with a written statement stating the total amount CENTIFIC owes you as of the date of termination. CENTIFIC will then pay that amount in accordance with the terms and procedures set forth in Section 3 of these Terms.",
    p20: "You understand and acknowledge that the closure of any project or the termination of any SOW will not automatically terminate this Agreement. and your access to OneForma has been terminated.",
    h_consequences: "2.3. Consequences of Termination",
    p21: "When this Agreement expires or terminates for any reason, or at any other time, upon the written request of CENTIFIC or the Project Owner, you shall, within three days of such expiration or termination, deliver to CENTIFIC and / or the Project Owner all deliverables (whether complete or incomplete) and all materials, equipment and other property provided to you by CENTIFIC or the Project Owner for your use;",
    p22: "Deliver to CENTIFIC or the project owner all tangible documents and other media, including any copies, that contain, reflect, incorporate, or are based on confidential information;",
    p23: "You must permanently delete all confidential information from your computer and photo system; and provide written confirmation to CENTIFIC and the project owner that you have complied with the requirements of this section. Unless otherwise provided by law, if your account is closed, you will no longer have access to any information or materials you store on OneForma, and any content stored in your account may be deleted, for which CENTIFIC expressly disclaims any liability. CENTIFIC may retain some or all of your account information as permitted or required by law and privacy policies.",
    h_payment: "3. Payment",
    h_payment_method: "3.1 Payment Method",
    p24: "Payments are made via Payoneer by default. By signing a contract with Payoneer or providing payment information to Payoneer through OneForma, you acknowledge and agree that: (a) your account with Payoneer and any related fund management services are governed solely by Payoneer's terms and conditions; (b) CENTIFIC is not responsible to you for the fund management services provided by Payoneer, and CENTIFIC makes no representations or warranties regarding such services; (c) CENTIFIC shall not be liable, directly or indirectly, for any actual or alleged damage or loss arising out of or in connection with the use of or reliance on the fund management services provided by Payoneer; and (d) you irrevocably waive any claims against CENTIFIC and its affiliates in connection with such fund management services. If you prefer other payment methods, please email omegaguttakdl53@gmail.com",
    p25: "You further acknowledge and agree that CENTIFIC shall not be liable for any payment failures resulting from applicable law or any restrictions imposed by your financial institution, or for any credit or debit entry by a financial institution relating to : your Payoneer account or any other payment method agreed upon by you and CENTIFIC. CENTIFIC will make commercially reasonable efforts to work with you to resolve such transactions in a manner consistent with this Agreement and any applicable law.",
    h_currency: "3.2. Currency and Payment Procedures",
    p26: "Depending on the project owner and services you choose to perform, CENTIFIC may decide at its own discretion to pay in US dollars, RMB, or any other currency.",
    h_prepay: "3.3. Prepayment Regulations",
    p27: "We partner with hotel merchants, and your current booking work is on a prepayment basis. Since OneForma only provides a part-time platform for all members, you need to provide funds upfront before undertaking prepayment tasks. After each order is completed, the system will automatically return the amount earned and your commission. Therefore, you need to start your work on a prepayment basis. By registering or using OneForma, you agree to be bound by this agreement. If you do not agree to any or all of this agreement, you may not register on OneForma. Please carefully read our relevant privacy policies and regulations.",
    h_nofees: "3.5. No obligation to pay fees",
    p28: "You shall bear all and every expense incurred by you, including but not limited to travel and other business expenses incurred by you or your employees, agents, or contractors in performing the services under this Agreement. Neither CENTIFIC nor the Project Owner shall be liable for any expenses incurred by you or your employees, agents, or contractors in performing their duties under this Agreement.",
    h_tax: "3.4. Taxation",
    p29: "For all users and taxpayers, all your taxes are paid in advance to OneForma. With any payment you make to OneForma, you acknowledge and agree that OneForma has withheld or paid any income, wages, Social Security, or other taxes. OneForma is not responsible for paying any insurance premiums (including unemployment or disability insurance premiums) or obtaining workers' compensation insurance. On your behalf, unless otherwise required by applicable law, you are liable to indemnify CENTIFIC for all such taxes or contributions, including penalties and interest.",
    p30: "For taxpayers in any other jurisdiction, you are liable for any taxes on payments received from OneForma. If you fail to pay taxes under applicable law, OneForma will freeze your account and provide proof of your tax evasion to the relevant tax jurisdiction without prior notice, directly contacting the court in your tax jurisdiction through OneForma.",
  },

  app: {
    rejected_title: "Withdrawal Rejected",
  },
};

export default en;
